export class FardeCreationBody {
  classementId: number;
  serviceId: number;
  serviceIds?: number[];
  description: string;
  localisation: string;
  remarques: string;
  classementAffine?: string;
  accesRestreint?: boolean;
  archive: boolean;
}
